import { FormDropdown } from "components/ui/forms/form-dropdown";
import { PropertyFieldSection } from "../../property-field-section";
import { useWatch } from "react-hook-form";
import { PropertySecurityTemplate } from "./property-security-template";
import { Fragment } from "react";
import { PropertySectionKind } from "../../../types/property-section.view-model";

export function PropertyFieldsEditable() {
  const security = useWatch({ name: "security" });

  return (
    <>
      <PropertySecurityTemplate
        title="Property Details"
        kind={PropertySectionKind.Section}
        securityNumber={0}
      />
      <PropertyFieldSection title="Securities" kind={PropertySectionKind.Section}>
        <FormDropdown
          name="security"
          label="Quantity of Security"
          options={["1", "2", "3", "4"]}
          placeholder="Select Quantity of Security"
        />
      </PropertyFieldSection>
      {security &&
        Array.from({ length: security }).map((_, securityIndex) => (
          <Fragment key={securityIndex}>
            <PropertySecurityTemplate
              title={`Security ${securityIndex + 1}`}
              kind={PropertySectionKind.Security}
              securityNumber={securityIndex + 1}
            />
          </Fragment>
        ))}
    </>
  );
}
